// @flow
export { default } from './QuotePlaceholder';



// WEBPACK FOOTER //
// ./src/components/quote/QuotePlaceholder/index.js